import requestService from "./requestService"

const request = requestService

export default {
    async getAll() {
        const all = await request.get('/customer-plans/all')
        return all
    }
}